import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EOverallScoreActionTypes {
  SetRating = 'NEW_REVIEW/OVERALL_SCORE/SET',
}

type TSetOverallScore = ITypedReduxAction<EOverallScoreActionTypes.SetRating, number>;

export const setOverallScore: (rating: number) => TSetOverallScore = actionGenerator<
  EOverallScoreActionTypes.SetRating,
  number
>(EOverallScoreActionTypes.SetRating);

export type TOverallScore = TSetOverallScore;
